export const SOURCES = {
    SENATORS_SELECT: 'senadoresSelect',
    WRITTEN_DESTINY: 'catalogo/opcion/Destinatarios',
};
